// extracted by mini-css-extract-plugin
export default {"faqSection":"faq_faqSection__dxA7p","heading":"faq_heading__mJWcP","list":"faq_list__i1Tfv"};